module.exports = __webpack_public_path__ + "static/media/o12.c427ede1.png";